import { HOUSEHOLD_AT_CONSTANTS, HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import { DEDUCTIBLE_HEADER } from '@flows/configs/shared/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { TransformedOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const household_at_quote = (params: StepConfigParams) =>
  ({
    validationStrategy: 'onChange',
    stepContent: [
      {
        type: 'customComponent',
        name: 'QuoteStep',
        props: {
          product: 'household_v1_getsafe_at',
          headerSubtitle: {
            type: 'translatableText',
            translationKey: 'sharedFlows_householdAt:steps.quote.subtitle',
            values: {
              square_meters: {
                type: 'dynamicValue',
                path: params.helperFunctions.getParamPath('square_meters'),
              },
              zip_code: {
                type: 'dynamicValue',
                path: 'zip_code',
              },
            },
          },
          configurableParameters: [
            DEDUCTIBLE_HEADER(),
            {
              type: 'dropDown',
              label: {
                type: 'translatableText',
                translationKey: 'sharedFlows_common:steps.deductibles',
              },
              useFilterInput: false,
              styleType: 'outlined',
              name: params.helperFunctions.getParamPath('deductible_amount'),
              options: HOUSEHOLD_AT_CONSTANTS.deductibleOptions.map((option): TransformedOption => {
                return {
                  value: Number(option),
                  label: {
                    type: 'nonTranslatableText',
                    text: params.clientHelpers.formatter.formatCurrency(option),
                  },
                }
              }),
            },
            {
              type: 'input',
              inputType: 'integer',
              name: params.helperFunctions.getParamPath('insured_sum_amount'),
              styleType: 'outlined',
              disabled: true,
              label: {
                type: 'translatableText',
                translationKey: 'sharedFlows_householdAt:steps.insured_sum.title',
              },
            },
          ],
        },
        inputs: [],
        outputs: [],
      },
    ],
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: 'household_v1_getsafe_at',
        },
        inputs: [],
        outputs: [],
      },
    },
    nextStep: HOUSEHOLD_STEPS.household_at_flood_area,
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default household_at_quote
